<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
                :title="pageTitle"
                :showBtn="true"
                @onClickCloseButton="navigateToListPage"
            />
        </div>
        <div class="my-2 px-2">
          <div class="mt-2 px-2">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
                <div class="mb-1">
                  <label for="colFormLabel" class="col-form-label">Month</label>
                  <vField
                      v-model="month"
                      name="month"
                      id="month"
                      type="month"
                      class="form-control"
                      :disabled="contactProfileId"
                  />
                </div>
              </div>

              <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
                <div class="mb-1">
                  <label for="colFormLabel" class="col-form-label">Staff Id</label>
                  <input
                      class="form-control invoice-edit-input  "
                      tabindex="1"
                      type="number"
                      placeholder="Enter Staff Id"
                      v-model="staffId"
                      :disabled="contactProfileId"
                  >
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
                <div class="mb-1">
                  <label for="colFormLabel" class="col-form-label">Team Member Id</label>
                  <input
                      class="form-control invoice-edit-input  "
                      tabindex="1"
                      type="number"
                      placeholder="Enter Allocated Staff Id"
                      v-model="teamMemberStaffId"
                  >
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-1 col-lg-1 mb-1 mt-2">
                <button
                    style="min-width: 64px;"
                    @click="onClickToGo"
                    class="btn btn-primary btn-block waves-effect waves-float waves-light"
                > Add
                </button>
              </div>
            </div>
          </div>

        </div>

        <div class="col-12 px-2 mb-1">
          <div class="card card-height">
            <div class="table-responsive">
              <table class="table custom-table-padding">
                <thead>
                <tr>
                  <th>Staff ID</th>
                  <th>Staff Name</th>
                  <th>Designation</th>
                  <th>Ref ID</th>
                  <th>Personal Sales Commission</th>
                  <th>Group Sales Commission</th>
                  <th>Company Sales Share</th>
                  <th>BP Commission</th>
                  <th>Total Commission</th>
                  <th>Service Charge</th>
                  <th>Net Commission</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in tableItems" :key="index">
                  <td>{{ item.serial_no }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.level_name }}({{ item.equivalent_designation}})</td>
                  <td>{{ item.parent_serial_no }}</td>
                  <td>{{ commaFormat(item.personal_sales_commission) }}</td>
                  <td>{{ commaFormat(item.total_group_commission_amount) }}</td>
                  <td>{{ commaFormat(item.total_company_sale_share) }}</td>
                  <td>{{ commaFormat(item.total_group_bp_commission_amount) }}</td>
                  <td>{{ commaFormat(item.total_commission) }}</td>
                  <td>{{ commaFormat(item.service_charge) }}</td>
                  <td>{{ commaFormat(item.net_commission) }}</td>
                  <td>
                    <button @click="onDeleteItem(item.contact_profile_owner_id)" class="btn btn-sm btn-danger">
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
            </div>
          </div>
        </div>

        <div class="row gy-1 p-2">
            <div class="col-md-4">
                <label for="colFormLabel" class="col-form-label">Voucher Date</label>
                <input
                    class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                    tabindex="1"
                    type="date"
                    placeholder="Select Voucher Date"
                    v-model="formData.voucher_date"
                >
            </div>
            <div class="col-md-4">
                <label for="colFormLabel" class="col-form-label">Paid From</label>
                <v-select
                    placeholder="Select Cash & Bank Account"
                    class="w-100"
                    v-model="formData.mop_account_head_id"
                    :options="cashAndBank"
                    label="name"
                    :reduce="name => name.id"
                />
            </div>
            <div class="col-md-4">
                <label for="colFormLabel" class="col-form-label">Payment Purpose</label>
                <v-select
                    placeholder="Select payment purpose"
                    class="w-100"
                    v-model="formData.payment_account_head_id"
                    :options="accountHeadList"
                    label="name"
                    :reduce="name => name.id"
                />
            </div>
            <div class="col-md-4">
                <label for="colFormLabel" class="col-form-label">Paid Amount</label>
                <input
                    :value="totalPaidAmount.toFixed(2)"
                    type="number"
                    class="form-control text-end"
                    placeholder="Amount"
                    disabled
                >
            </div>

            <div class="col-12">
                <div class="mb-1">
                    <label class="form-label" for="remarks">Remarks</label>
                    <vField
                        as="textarea"
                        name="remarks"
                        type="number"
                        class="form-control"
                        placeholder="Enter Remarks"
                        v-model="formData.remarks"
                    />
                </div>
            </div>

            <div class="col-12 text-center mb-2">
                <hr>
              <button :disabled="isLoading" @click="submit()"
                      class="btn btn-primary">
                Save
              </button>
              <button :disabled="isLoading" @click="submit(true)"
                      class="btn btn-primary mx-1">
                Save & Print
              </button>
            </div>
        </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {computed, inject, onMounted, ref} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handlePayment from '@/services/modules/payment'
import handleJournal from '@/services/modules/journal'
import handleSdm from "@/services/modules/sdm/sdm";
import figureFormatter from "@/services/utils/figureFormatter";
import incentivePaymentVoucherPdfHelper from "@/services/utils/incentivePaymentVoucherPdfHelper";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const contactProfile = ref(null);
const accountHeads = ref([]);
const accountHeadList = ref([]);
const tableItems = ref([]);
const cashAndBank = ref([]);
const params = ref({
    offset: 10,
});
const isLoading = ref(false);
const staffId = ref(null);
const month = ref(null);
const paymentRes = ref({});
const teamMemberStaffId = ref(null);
const contactProfileId = ref(null);
const { commaFormat } = figureFormatter();

const formData = ref({
    company_id: route.params.companyId,
    contact_profile_id: null,
    voucher_date: null,
    payment_account_head_id: null,
    mop_account_head_id: null,
    amount: null,
})

const { fetchCashAndBank } = handlePayment()
const {
  fetchIncentiveAmount,
  storeIncentivePaymentVoucher,
  updateIncentivePaymentVoucher,
  fetchSingleIncentivePaymentVoucher
} = handleSdm()
const { fetchAccountHeadsList } = handleJournal();
const { generatePdf } = incentivePaymentVoucherPdfHelper();

const isEdit = computed(() => Boolean(route.params.voucherId))

const pageTitle = computed(() => {
  if (isEdit.value) return 'Edit Incentive Payment Voucher'
  return 'Incentive Payment Voucher'
})

const saveVoucher = () => {
  if (isEdit.value) return updateIncentivePaymentVoucher(route.params.voucherId, formData.value)
  return storeIncentivePaymentVoucher(formData.value)
}

const submit = async (print = false) => {
    formData.value.contact_profile_id = contactProfileId.value;
    formData.value.contact_profile_owner_id = tableItems.value
        .map(item => item.contact_profile_owner_id)
    formData.value.amount = totalPaidAmount.value;
    formData.value.month = month.value;
    isLoading.value = true

    await saveVoucher().then((res) => {
        isLoading.value = false
        if (!res.status) return showError(res.message);
        showSuccess(res.message);
        if(print) goToPrint(res.data.id)
        if (isEdit.value) return navigateToListPage()
        resetForm()
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        isLoading.value = false
    })
}

const goToPrint = (id) => {
  let companyId = route.params.companyId;
  const companyQuery = `?company_id=${companyId}`;
  fetchSingleIncentivePaymentVoucher(id, companyQuery).then( (res) => {
    if(res){
      paymentRes.value = res.data;
    }}).then (() => {
    generatePdf(companyId, paymentRes.value)
  }).catch((err) => {
    console.log('Something went wrong');
  })
}

const resetForm = () => {
   formData.value.contact_profile_id = null;
   formData.value.payment_account_head_id = null;
   formData.value.mop_account_head_id = null;
   formData.value.amount = null;
   formData.value.contact_profile_owner_id = null;
   contactProfileId.value = null;
   month.value = null;
   staffId.value = null;
   teamMemberStaffId.value = null;
   tableItems.value = [];
}

const onDeleteItem = (ownerId) => {
  tableItems.value = tableItems.value.filter(
      item => item.contact_profile_owner_id !== ownerId
  )
}

const onClickToGo = async () => {
  const query = getQuery();
  loading.value = true

  await fetchIncentiveAmount(query).then(res => {
    if (!res.status){
      showError(res.message)
      return
    }

    const newData = res.data.data
    tableItems.value = [
      ...tableItems.value.filter(
          item => item.contact_profile_owner_id !== newData.contact_profile_owner_id
      ),
      newData
    ]
    contactProfileId.value = res.data.contact_profile_id

  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const totalPaidAmount = computed(() => {
  return tableItems.value.reduce((sum, item) => {
    return sum + Number(item.net_commission || 0)
  }, 0)
})

const getCashAndBank = async () => {
    let res = await fetchCashAndBank(route.params.companyId);
    if (res.status) {
      cashAndBank.value = res.data;
    }
}

const getAccountHeadList = async () => {
    let accountHeadQuery = `?company_id=${route.params.companyId}&cash_bank_hide=yes&status=active`;
    const res = await fetchAccountHeadsList(accountHeadQuery);
    if (res.status) {
        accountHeadList.value = res.data
    }
}

const getQuery = () => {
  let query = `?company_id=${route.params.companyId}`;
  if (staffId.value) query += '&staff_id=' + staffId.value;
  if (teamMemberStaffId.value) query += '&team_member_staff_id=' + teamMemberStaffId.value;
  if (month.value) query += '&month=' + month.value;
  if (isEdit.value) query += '&ledger_master_id=' + route.params.voucherId;
  return query;
}

const setVoucherData = (data) => {
  const voucher = data.data
  const voucherFormData = data.form_data
  month.value = voucherFormData.month
  staffId.value = voucher.serial_no
  contactProfileId.value = voucher.contact_profile_id
  formData.value.voucher_date = voucher.date
  formData.value.remarks = voucher.note
  formData.value.payment_account_head_id = voucherFormData.payment_account_head_id
  formData.value.mop_account_head_id = voucherFormData.mop_account_head_id
  tableItems.value = data.incentive_payment
}

const getVoucherData = async () => {
  if (!isEdit.value) return
  const companyQuery = `?company_id=${route.params.companyId}`;
  loading.value = true

  await fetchSingleIncentivePaymentVoucher(route.params.voucherId, companyQuery).then(res => {
    if (!res.status) {
      showError(res.message)
      return
    }
    setVoucherData(res.data)
  }).catch(() => {
    showError('Something went wrong')
  }).finally(() => {
    loading.value = false
  })
}

function navigateToListPage() {
  router.push({
    name: `incentive-payment-voucher-list`,
    params: {
      companyId: route.params.companyId,
      moduleId: route.params.moduleId,
      menuId: route.params.menuId,
      pageId: route.params.pageId
    },
    query: route.query
  });
}

onMounted(() => {
    formData.value.voucher_date = new Date().toISOString().split('T')[0]
    Promise.all([
        getCashAndBank(),
        getAccountHeadList(),
        getVoucherData()
    ]);
})

</script>

<style>

</style>